import React from 'react'

import Col from 'react-bootstrap/Col'
import Row from 'react-bootstrap/Row'
import Card from 'react-bootstrap/Card'

import { useSignup } from './Signup.hooks'

const BillingInfo = () => {
  const { billing } = useSignup()

  if (!billing) return null
  return (
    <>
      <Card>
        <Card.Body>
          <Row>
            <Col>
              <h6 className="signup__label--small">Name</h6>
              {billing.firstName} {billing.lastName}
            </Col>
            <Col>
              <h6 className="signup__label--small">Email</h6>
              {billing.email}
            </Col>

            <Col>
              {billing.phone && (
                <>
                  <h6 className="signup__label--small">Telefon</h6>
                  {billing.phone}
                </>
              )}
            </Col>
          </Row>

          <Row className="mt-2">
            <Col>
              <h6 className="signup__label--small">Adresse</h6>
              {billing.address1}
              {billing.address2 && ', ' + billing.address2}
              {', '}
              {billing.zip} {billing.city}
              {' ('}
              {billing.country}
              {')'}
            </Col>
          </Row>
        </Card.Body>
      </Card>
    </>
  )
}

export default BillingInfo
